import { createStore } from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agentCapacityPolicies from './modules/agentCapacityPolicies';
import wgptBoards from './modules/wgptBoards';
import wgptBoardLists from './modules/wgptBoardLists';
import wgptBoardListCards from './modules/wgptBoardListCards';
import wgptBoardListCardActivities from './modules/wgptBoardListCardActivities';
import wgptAutomations from './modules/wgptAutomations';
import wgptAutomationRegistry from './modules/wgptAutomationRegistry';
import wgptAutomationBuilder from './modules/wgptAutomationBuilder';
import wgptAuditTrail from './modules/wgptAuditTrail';
import wgptBotKnowledgeManager from './modules/wgptBotKnowledgeManager';
import wgptBots from './modules/wgptBots';
import wgptBotSources from './modules/wgptBotSources';
import wgptBotSourceChunks from './modules/wgptBotSourceChunks';
import wgptBotTools from './modules/wgptBotTools';
import wgptMcpServers from './modules/wgptMcpServers';
import wgptSocialMediaPosts from './modules/wgptSocialMediaPosts';
import wgptTasks from './modules/wgptTasks';
import wgptTaskExecutions from './modules/wgptTaskExecutions';
import wgptBotEvalCriteria from './modules/wgptBotEvalCriteria';
import wgptBotEvalResults from './modules/wgptBotEvalResults';
import wgptBotEvalRecommendations from './modules/wgptBotEvalRecommendations';
import wgptBotWorkflows from './modules/wgptBotWorkflows';
import wgptBotWorkflowStages from './modules/wgptBotWorkflowStages';
import wgptCampaigns from './modules/wgptCampaigns';
import wgptCarCatalog from './modules/wgptCarCatalog';
import wgptCarListings from './modules/wgptCarListings';
import wgptCarShowroom from './modules/wgptCarShowroom';
import wgptContactCards from './modules/wgptContactCards';
import wgptIntegrations from './modules/wgptIntegrations';
import wgptOnboarding from './modules/wgptOnboarding';
import wgptReports from './modules/wgptReports';
import wgptSamlProviders from './modules/wgptSamlProviders';
import wgptCustomReports from './modules/wgptCustomReports';
import wgptCustomDashboards from './modules/wgptCustomDashboards';
import wgptEventDefinitions from './modules/wgptEventDefinitions';
import wgptEventAutomations from './modules/wgptEventAutomations';
import agents from './modules/agents';
import assignmentPolicies from './modules/assignmentPolicies';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auditlogs from './modules/auditlogs';
import auth from './modules/auth';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationUnreadCounts from './modules/conversationUnreadCounts';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customRole from './modules/customRole';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import draftMessages from './modules/draftMessages';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import macros from './modules/macros';
import notifications from './modules/notifications';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import sla from './modules/sla';
import slaReports from './modules/SLAReports';
import sidebarSortPreferences from './modules/sidebarSortPreferences';
import summaryReports from './modules/summaryReports';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import captainAgentSessions from './captain/agentSessions';
import captainAssistants from './captain/assistant';
import captainDocuments from './captain/document';
import captainResponses from './captain/response';
import captainFaqSuggestions from './captain/faqSuggestions';
import captainInboxes from './captain/inboxes';
import captainBulkActions from './captain/bulkActions';
import copilotThreads from './captain/copilotThreads';
import copilotMessages from './captain/copilotMessages';
import captainScenarios from './captain/scenarios';
import captainTools from './captain/tools';
import captainCustomTools from './captain/customTools';

const plugins = [];

export default createStore({
  modules: {
    accounts,
    agentBots,
    agentCapacityPolicies,
    wgptBoards,
    wgptBoardLists,
    wgptBoardListCards,
    wgptBoardListCardActivities,
    wgptAutomations,
    wgptAutomationRegistry,
    wgptAutomationBuilder,
    wgptAuditTrail,
    wgptBotKnowledgeManager,
    wgptBots,
    wgptBotSources,
    wgptBotSourceChunks,
    wgptBotTools,
    wgptMcpServers,
    wgptSocialMediaPosts,
    wgptTasks,
    wgptTaskExecutions,
    wgptBotEvalCriteria,
    wgptBotEvalResults,
    wgptBotEvalRecommendations,
    wgptBotWorkflows,
    wgptBotWorkflowStages,
    wgptCampaigns,
    wgptCarCatalog,
    wgptCarListings,
    wgptCarShowroom,
    wgptContactCards,
    wgptIntegrations,
    wgptOnboarding,
    wgptReports,
    wgptSamlProviders,
    wgptCustomReports,
    wgptCustomDashboards,
    wgptEventDefinitions,
    wgptEventAutomations,
    agents,
    assignmentPolicies,
    articles,
    attributes,
    auditlogs,
    auth,
    automations,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationUnreadCounts,
    conversationWatchers,
    csat,
    customRole,
    customViews,
    dashboardApps,
    draftMessages,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    labels,
    macros,
    notifications,
    portals,
    reports,
    sla,
    slaReports,
    sidebarSortPreferences,
    summaryReports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    captainAgentSessions,
    captainAssistants,
    captainDocuments,
    captainResponses,
    captainFaqSuggestions,
    captainInboxes,
    captainBulkActions,
    copilotThreads,
    copilotMessages,
    captainScenarios,
    captainTools,
    captainCustomTools,
  },
  plugins,
});
